"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// inspired from https://github.com/ctrlplusb/react-universally
exports.isBrowser = process.env.IS_BROWSER;
exports.isDev = process.env.NODE_ENV === 'development';
exports.isProd = ['production', 'stage'].includes(process.env.NODE_ENV);
exports.isServer = !process.env.IS_BROWSER;
exports.isStage = process.env.NODE_ENV === 'stage';
exports.isBeta = process.env.NODE_ENV === 'beta';
exports.isTest = process.env.NODE_ENV === 'test';
//# sourceMappingURL=env.js.map